module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-right-6.e024dffd.png";